import { ArrowRight } from "lucide-react";
import { GridField } from "./decor";
import { PILLARS } from "../data";
import { Reveal, CTAButton } from "./primitives";

export const Framework = () => {
  return (
    <section id="framework" data-testid="framework-section" className="relative isolate bg-white py-24 md:py-32">
      <GridField className="opacity-[0.05]" />
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <Reveal>
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-[#5C8A1E] sm:text-base">
            The 5-Pillar Framework
          </span>
          <h2 className="mt-4 max-w-2xl font-serif text-3xl font-medium tracking-tight text-[#1b1f17] sm:text-4xl lg:text-5xl">
            One system to engineer predictable enterprise revenue.
          </h2>
        </Reveal>

        {/* Horizontal process-flow chart */}
        <div className="relative mt-20">
          {/* connector line (desktop) */}
          <div className="absolute left-[8%] right-[8%] top-[44px] hidden h-0.5 bg-gradient-to-r from-[#8CC63F]/20 via-[#8CC63F] to-[#8CC63F]/20 lg:block" />

          <div className="grid gap-y-12 sm:grid-cols-2 lg:grid-cols-5 lg:gap-x-4">
            {PILLARS.map((pillar, i) => {
              const Icon = pillar.icon;
              return (
                <Reveal key={i} delay={i * 0.08}>
                  <div data-testid={`pillar-${i}`} className="group flex flex-col items-center px-2 text-center">
                    <div className="relative">
                      <span className="grid h-[88px] w-[88px] place-items-center rounded-full border-2 border-[#8CC63F] bg-white shadow-[0_10px_28px_rgba(140,198,63,0.22)] transition-transform duration-300 group-hover:-translate-y-1.5">
                        <Icon className="h-8 w-8 text-[#5E9E1F]" strokeWidth={1.7} />
                      </span>
                      <span className="absolute -right-1 -top-1 grid h-8 w-8 place-items-center rounded-full bg-[#5E9E1F] font-serif text-sm font-bold text-white shadow-[0_4px_10px_rgba(94,158,31,0.4)]">
                        {pillar.n}
                      </span>
                    </div>
                    <h3 className="mt-6 max-w-[16rem] font-serif text-lg font-medium leading-snug text-[#1b1f17]">
                      {pillar.name}
                    </h3>

                    {/* mobile flow arrow */}
                    {i < PILLARS.length - 1 && (
                      <ArrowRight className="mt-6 h-5 w-5 rotate-90 text-[#8CC63F] sm:hidden" />
                    )}
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 flex justify-center">
            <CTAButton testId="framework-cta" href="#contact">
              Book a Discovery Call <ArrowRight className="h-4 w-4" />
            </CTAButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
